import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-xl border-b border-slate-200 shadow-sm" data-id="element-364">
      <div className="container mx-auto px-6 py-5" data-id="element-365">
        <div className="flex justify-between items-center" data-id="element-366">
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-12" data-id="element-367">
            <Link to="/" className={`transition-colors font-medium text-base ${isActive('/') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} data-id="element-368">
              Home
            </Link>
            <Link to="/clinics" className={`transition-colors font-medium text-base ${isActive('/clinics') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} data-id="element-369">
              Partner Clinics
            </Link>
            <Link to="/packages" className={`transition-colors font-medium text-base ${isActive('/packages') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} data-id="element-370">
              Packages
            </Link>
            <Link to="/treatments" className={`transition-colors font-medium text-base ${isActive('/treatments') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} data-id="element-371">
              Treatments
            </Link>
            <Link to="/about" className={`transition-colors font-medium text-base ${isActive('/about') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} data-id="element-372">
              About
            </Link>
          </nav>
          {/* CTA Button */}
          <Link to="/contact" className="hidden lg:block bg-blue-600 text-white px-8 py-3 rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-blue-600/30 font-semibold text-base ml-auto" data-id="element-373">
            Free Consultation
          </Link>
          {/* Mobile menu button */}
          <div className="lg:hidden ml-auto" data-id="element-374">
            <button onClick={toggleMenu} className="text-slate-600" data-id="element-375">
              {isMenuOpen ? <XIcon size={24} data-id="element-376" /> : <MenuIcon size={24} data-id="element-377" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-slate-200" data-id="element-378">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-379">
            <Link to="/" className={`py-2 transition-colors font-medium ${isActive('/') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} onClick={toggleMenu} data-id="element-380">
              Home
            </Link>
            <Link to="/clinics" className={`py-2 transition-colors font-medium ${isActive('/clinics') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} onClick={toggleMenu} data-id="element-381">
              Partner Clinics
            </Link>
            <Link to="/packages" className={`py-2 transition-colors font-medium ${isActive('/packages') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} onClick={toggleMenu} data-id="element-382">
              Packages
            </Link>
            <Link to="/treatments" className={`py-2 transition-colors font-medium ${isActive('/treatments') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} onClick={toggleMenu} data-id="element-383">
              Treatments
            </Link>
            <Link to="/about" className={`py-2 transition-colors font-medium ${isActive('/about') ? 'text-blue-600' : 'text-slate-600 hover:text-blue-600'}`} onClick={toggleMenu} data-id="element-384">
              About
            </Link>
            <Link to="/contact" className="bg-blue-600 text-white px-4 py-3 rounded-full hover:bg-blue-700 transition-colors w-full text-center font-semibold" onClick={toggleMenu} data-id="element-385">
              Free Consultation
            </Link>
          </div>
        </div>}
    </header>;
}